import React, { useEffect, useState, useRef, forwardRef, useImperativeHandle } from 'react';
import styles from './index.module.scss';

interface MenuData {}

export interface MenuProps {
  targetElementClassName?: string;
  isAutoListenEvent?: boolean;
  menu?: React.ReactNode;
  menuData?: MenuData[];
  position?: { left: number; top: number };
  style?: { [propsName: string]: any };
  [propsName: string]: any;
}

const ContextMenu: React.FC<MenuProps> = forwardRef((props, ref) => {
  const menuRef = useRef<any>(null);

  const {
    targetElementClassName,
    // targetElement,
    isAutoListenEvent = true,
    menu,
    position,
    style,
  } = props;

  const [visible, setVisible] = useState<boolean>(false);
  const [currentEvent, setCurrentEvent] = useState<Event | null>(null);

  const handleContextMenu = (event: MouseEvent, pos?: any) => {
    // 判断是否在electron壳子内部
    const { userAgent = '' } = window.navigator;
    const versionArr = userAgent.match(/version=(\S*)-/);
    const version = versionArr ? versionArr[1] || null : null;
    if (!version) return;

    setCurrentEvent(event);
    setVisible(false);

    const className = (event.target as any)?.className;

    if (!(targetElementClassName && className && className.includes(targetElementClassName))) {
      return;
    }

    event.preventDefault();

    setVisible(true);

    // 获取可视区宽度
    const winWidth = function () {
      return document.documentElement.clientWidth || document.body.clientWidth;
    };
    // 获取可视区高度
    const winHeight = function () {
      return document.documentElement.clientHeight || document.body.clientHeight;
    };

    const rightMenu = menuRef.current;
    let l = event.clientX;
    let t = event.clientY;

    if (pos) {
      l = pos.left;
      t = pos.top;
    }

    if (l >= winWidth() - rightMenu?.offsetWidth) {
      l = winWidth() - rightMenu?.offsetWidth;
    }
    if (t > winHeight() - rightMenu?.offsetHeight) {
      t = winHeight() - rightMenu?.offsetHeight;
    }

    if (rightMenu) {
      rightMenu.style.left = `${l}px`;
      rightMenu.style.top = `${t}px`;
    }

    // eslint-disable-next-line consistent-return
    return false;
  };

  const closeMenu = () => {
    setVisible(false);
  };
  const openMenu = () => {
    setVisible(true);
  };

  const handleClick = () => {
    setVisible(false);
  };
  const handleScroll = () => {
    setVisible(false);
  };

  useImperativeHandle(ref, () => ({
    menuRef,
    visible,
    event: currentEvent,
    handleContextMenu,
    closeMenu,
    openMenu,
  }));

  useEffect(() => {
    if (isAutoListenEvent) {
      document.addEventListener('contextmenu', handleContextMenu);
      document.addEventListener('click', () => handleClick());
      document.addEventListener('scroll', handleScroll);
    }

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('click', handleClick);
      document.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return visible ? (
    <div className={styles.menu} id="context-menu" ref={menuRef} style={style || {}}>
      {props.children || menu}
    </div>
  ) : (
    <></>
  );
});

export default ContextMenu;
